export default __webpack_public_path__ + "01e9be479827bde0f993dc0f79961d1a.woff";